import SectionTitle from '../../common/SectionTitle'

import './_ServicesSection.scss'

import img1 from '../../../assets/images/services-section/img1.png'
import img2 from '../../../assets/images/services-section/img2.png'
import img3 from '../../../assets/images/services-section/img3.png'

const ServiceItem = ({ img, title, text }) => (
  <div className='service-item'>
    <div className='img-box'>
      <img src={img} alt={title} />
    </div>
    <div className='text-box'>
      <h3 className='title'>{title}</h3>
      { text instanceof Array ?
        <div className='texts'>{text.map(string => <p className='text' key={string}>{string}</p>)}</div> :
        <p className='text'>{text}</p>
      }
    </div>
  </div>
)

const serviceItems = [{
  img: img1,
  title: 'Mobile medical unit',
  text: ['Our Mobile Medical Unit is a unique service that provides highly technical medical diagnostic or treatment measures.', "We can come to the customer's desired location on demand."],
}, {
  img: img2,
  title: 'Appointments with your doctor',
  text: 'Book a same-day appointment with a compassionate provider who collaborates with you to create a treatment plan that fits your needs and your life. Our appointments start on time and we offer on-site lab testing, so you can get care and get back to your day quickly.',
}, {
  img: img3,
  title: 'Anytime access to medical care via our app',
  text: "The human body doesn't follow normal business hours — and neither do we. Get on-demand care over video chat or messages anytime and potentially skip an unnecessary and expensive trip to the ER or urgent care.",
}]

const ServicesSection = () => {
  return (
    <div className='ServicesSection section-padding' id='services'>
      <div className='container'>
        <SectionTitle
          title='Our services'
          text='What we do for our clients'
          sm
        />
        <div className='services-box'>
          {serviceItems.map(service => <ServiceItem {...service} key={service.title} />)}
        </div>
      </div>
    </div>
  )
}

export default ServicesSection
